import { Route } from '@angular/router';
import { IsAuthenticatedGuard } from '@principle-theorem/ng-auth';
import {
  PartnerUserEditComponent,
  PartnerUserListComponent,
  PartnerUserResolver,
} from '@principle-theorem/ng-principle/pages';
import {
  IsAuthorisedGuard,
  IsPartnerWorkspaceGuard,
} from '@principle-theorem/ng-principle-shared';
import { AppSettingsComponent } from './app-settings/app-settings.component';
import { AppViewComponent } from './app-view/app-view.component';
import { AppWebhooksComponent } from './app-webhooks/app-webhooks.component';
import { PartnerAppResolver } from './partner-app-resolver.service';
import { PartnerViewComponent } from './partner-view/partner-view.component';

export const APP_ROUTES: Route[] = [
  {
    path: '',
    children: [
      {
        path: '',
        component: PartnerViewComponent,
        canActivate: [
          IsAuthenticatedGuard,
          IsAuthorisedGuard,
          IsPartnerWorkspaceGuard,
        ],
      },
      {
        path: '',
        loadChildren: () =>
          import('./auth/auth-pages-routing.module').then(
            (mod) => mod.AuthPagesRoutingModule
          ),
      },
      {
        path: 'apps/:uid',
        component: AppViewComponent,
        resolve: {
          partnerApp: PartnerAppResolver,
        },
        children: [
          {
            path: '',
            redirectTo: 'settings',
            pathMatch: 'full',
          },
          {
            path: 'settings',
            component: AppSettingsComponent,
          },
          {
            path: 'webhooks',
            component: AppWebhooksComponent,
          },
        ],
      },
      {
        path: 'users',
        children: [
          {
            path: '',
            component: PartnerUserListComponent,
          },
          {
            path: ':uid',
            resolve: {
              user: PartnerUserResolver,
            },
            children: [
              {
                path: '',
                component: PartnerUserEditComponent,
              },
            ],
          },
        ],
      },
    ],
  },
];
